import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class AddressProofError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AddressProofError', ...args);
    }
}
export default AddressProofError;
